var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-icon',{attrs:{"color":"blue darken-2","aria-label":'actualizar carpeta ' + _vm.folder.nombre},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.icon.pencil))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }